import './TradingTokenItemHolder.scss';
import { useTranslation } from 'react-i18next';
import { assets } from '../../../../assets/assets';
import { getUIStateClassName } from '../../../../data/utils';
import { app } from '../../../../data/AppController';
import {
  displayTokenAmount,
  formatPrice,
  largeIntegerToLetter,
} from '../../../../replicant/utils/numbers';
import { TradingTokenListing } from '../../../../replicant/features/offchainTrading/types';
import { useEffect, useState } from 'react';
import Big from 'big.js';
import { offchainTokenDisplayMultiplier } from '../../../../replicant/features/offchainTrading/offchainTrading.ruleset';

interface Props {
  offchainTokenData: TradingTokenListing;
}

export const TradingTokenItemHolder = ({ offchainTokenData }: Props) => {
  const { t } = useTranslation();

  const {
    name,
    offchainTokenId,
    image,
    creatorId,
    creatorName,
    marketCap,
    ticker,
  } = offchainTokenData;

  const tickerName = ticker;

  const onShowOffchainTokenDetails = async () => {
    app.nav.goToTradingToken(offchainTokenId);
  };

  useEffect(() => {
    // app.trading.foo2(offchainTokenId).then((data) => {
    //   data && setPcts(data);
    // });
    // app.trading.foo3(offchainTokenId).then((data) => {
    //   console.log({ data });
    // });
    // app.trading.foo4().then((graph) => {
    //   console.log({ graph });
    // });
  }, [offchainTokenId]);

  if (!app.views.TradingPage.visible) {
    return null;
  }

  // todo(Cai): profile token data needs to have -> tokenAmount, holdingsData.valuation, holdingStats.roi

  const myToken = app.state.trading.offchainTokens[offchainTokenId];
  const holdingStats = app.trading.getOffchainTokenHoldingStats(
    offchainTokenId,
    myToken,
  );
  const roi = holdingStats.roi;

  const color = roi === 0 ? 'white' : roi > 0 ? 'green' : 'red';
  const iconArrow = roi > 0 ? assets.arrow_up_green : assets.arrow_down_red;

  const tokenAmount = Big(myToken?.tokenAmount || 0).toNumber();
  const owned = displayTokenAmount(
    tokenAmount,
    4,
    tokenAmount < 1000 / offchainTokenDisplayMultiplier,
  );

  return (
    <div
      className={`btn trading-token-item-holder ${getUIStateClassName(
        app.ui.getCardState(offchainTokenId),
      )}`}
      onClick={onShowOffchainTokenDetails}
    >
      <div className="trading-token-item-holder-container">
        <div className="trading-token-item-holder-image">
          <img src={image} />
        </div>

        <div className="trading-token-item-holder-content">
          <div className="left">
            <div className="name-container">
              <div className="tickername">{tickerName}</div>
              <div className="tokenname">{name}</div>
            </div>
            <div className="owned-container">
              <div
                className="value"
                dangerouslySetInnerHTML={{
                  __html: owned,
                }}
              ></div>
              <div className="label">Owned</div>
            </div>
          </div>

          <div className="right">
            <div className="price-container">
              <div className="coin">
                <img src={assets.coin} />
              </div>
              <div className="value">
                {largeIntegerToLetter(holdingStats.valuation, 3)}
              </div>
            </div>
            <div className="percent-container">
              <div className={`arrow ${color}`}>
                {roi !== 0 && <img src={iconArrow} />}
              </div>
              <div className={`percent ${color}`}>
                {formatPrice(Math.round(roi))}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
